import CourseCard from 'components/CourseDashboard/CourseCard';
import NoCourses from 'components/CourseDashboard/NoCourses';
import { useTranslation } from 'react-i18next';
import { Button, Container, Icon, IconButton, Loading, Stack, styled, Tabs, Text, TextInput } from 'shell/components';

const Desktop = ({
    loading,
    courses,
    filteredCourses,
    searchBarInput,
    has_instructor,
    onChangeSearchBarInput,
    setIsFilterDrawerOpen,
    selectCourse,
    handleImportCourse,
    handleCourseCardDropdown,
    viewArchived,
    setViewArchived,
    hasCoursesInView,
}) => {
    const { t } = useTranslation('course');
    if (!courses) return <Loading />;

    return (
        <Container device={'desktop'}>
            <Stack sx={{ width: '100%' }} spacing={4}>
                <Stack spacing={4}>
                    <HeaderStack alignItems={'flex-start'} direction={'row'} justifyContent={'space-between'}>
                        <Text component={'h1'} variant={'h6'} weight={'medium'}>
                            {t('course-lobby.title', 'Course Lobby')}
                        </Text>
                        <Stack alignItems={'center'} direction={'row'} spacing={4}>
                            <Button
                                color={'neutral'}
                                startIcon={<Icon kind={'filter'} />}
                                variant={'secondary'}
                                onClick={() => setIsFilterDrawerOpen(true)}
                            >
                                {t('common:controls.filters', 'Filters')}
                            </Button>
                            <CustomTextInput
                                disablePointerEventsOnIcon={!Boolean(searchBarInput)}
                                endIcon={
                                    searchBarInput ? (
                                        <IconButton
                                            aria-label={'clear search input'}
                                            kind={'exit'}
                                            variant={'square'}
                                            onClick={() => onChangeSearchBarInput('')}
                                            onMouseDown={(e) => e.preventDefault()}
                                        />
                                    ) : (
                                        <Icon kind={'search'} />
                                    )
                                }
                                placeholder={t('common:controls.search', 'Search')}
                                value={searchBarInput}
                                onChange={(e) => onChangeSearchBarInput(e.target.value)}
                            />
                            {has_instructor && (
                                <Button
                                    className={'joyride-step-1'}
                                    loading={loading}
                                    loadingGrow
                                    startIcon={<Icon kind={'add'} />}
                                    onClick={handleImportCourse}
                                >
                                    {t('course-lobby.import-course', 'Import Course')}
                                </Button>
                            )}
                        </Stack>
                    </HeaderStack>
                    <Tabs
                        aria-label={'course lobby tabs'}
                        options={[
                            { key: 'current', value: t('course-lobby.current-courses', 'Current Courses') },
                            { key: 'archived', value: t('course-lobby.archived-courses', 'Archived Courses') },
                        ]}
                        selected={viewArchived ? 'archived' : 'current'}
                        onChange={(key) => setViewArchived(key === 'archived')}
                    />
                </Stack>
                {!hasCoursesInView && <NoCourses type={viewArchived ? 'archived' : 'active'} />}
                {!!filteredCourses.length && (
                    <CoursesStack alignItems={'flex-start'} direction={'row'} justifyContent={'flex-start'} spacing={3}>
                        {filteredCourses.map((course, index) => {
                            return (
                                <CourseCard
                                    key={course.course_id}
                                    className={!index ? 'joyride-step-2' : undefined}
                                    course={course}
                                    handleCourseCardDropdown={handleCourseCardDropdown}
                                    onClick={selectCourse}
                                />
                            );
                        })}
                    </CoursesStack>
                )}
            </Stack>
        </Container>
    );
};

const HeaderStack = styled(Stack)(() => {
    return { width: '100%' };
});

const CoursesStack = styled(Stack)(({ theme }) => {
    return {
        flexWrap: 'wrap',
        marginBottom: theme.spacing(8),
        width: '100%',
    };
});

const CustomTextInput = styled(TextInput)(() => {
    return {
        width: '13.5rem',
    };
});

export default Desktop;
